// Tek kaynaklı kurumsal kimlik / iletişim bilgileri.
// Trust sayfaları (Hakkımızda, Destek, Gizlilik, Fiyat) buradan okur — tek yerden düzenle.
//
// NOT (Volkan): `phone` boşsa sayfalarda hiç gösterilmez. Kurumsal bir telefon
// numarası eklemek "erişilebilir firma" güven sinyali verir; hazır olduğunda doldur.

export const SITE = {
  product: 'W.Sign',
  company: 'WSOFT Yazılım',
  city: 'Ankara, Türkiye',
  // Firmanın görünür yüzü — kişisel ad değil, kurumsal kimlik.
  ceoName: 'Buket Şendağ',
  ceoTitle: 'Kurucu & Genel Müdür',
  foundedYear: 2024,

  email: {
    general: 'iletisim@wsoft.tr',
    sales: 'iletisim@wsoft.tr',
    support: 'destek@wsoft.tr',
    security: 'security@wsoft.tr',
    kvkk: 'kvkk@wsoft.tr',
  },

  // Boş bırakılırsa UI'da gösterilmez. Örn: '+90 312 000 00 00'
  phone: '+90 505 431 26 00' as string,

  corpUrl: 'https://wsoft.tr',
  signUrl: 'https://sign.wsoft.tr',
  apiUrl: 'https://api.sign.wsoft.tr',

  // Windows kurulum paketi (Velopack). Kurulan kopya ayni klasordeki releases.win.json'dan
  // kendini gunceller. TEK KAYNAK: dort ayri sayfa bu linki gosteriyor; elle kopyalanirsa
  // biri gunceltilmeden kalir (nitekim eski "downloads/bridge" linki tam bunu yasadi).
  downloadUrl: 'https://sign.wsoft.tr/downloads/desktop/WSign-win-Setup.exe',
} as const

export function mailto(addr: string, subject?: string): string {
  return subject ? `mailto:${addr}?subject=${encodeURIComponent(subject)}` : `mailto:${addr}`
}
